/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { ContactsOutlined, IdcardOutlined } from '@ant-design/icons'
import { Modal, Tabs } from 'antd'
import Status from './status'
import Record from './record'
const TabPane = Tabs.TabPane

export default class extends React.Component {
  render() {
    const { visible, record, tbDetail, billRecord, billRecordDetail } =
      this.props
    return (
      <div>
        <Modal
          title={record.name}
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1000px"
          footer={null}
        >
          <Tabs defaultActiveKey="1" onTabClick={this.onTabClick}>
            <TabPane
              tab={
                <span>
                  <IdcardOutlined />
                  球台实况
                </span>
              }
              key="1"
            >
              <Status record={record} tbDetail={tbDetail} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <ContactsOutlined />
                  账单记录
                </span>
              }
              key="2"
            >
              <Record
                record={record}
                billRecord={billRecord}
                billRecordDetail={billRecordDetail}
                fetchClubSettlement={this.props.fetchClubSettlement}
                fetchBillRecordDetail={this.props.fetchBillRecordDetail}
              />
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/component/modal.js